var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPolygonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 75,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1476 9.04684C23.5571 8.69887 22.7896 8.69887 22.1403 9.04684L17.535 11.7146L14.4059 13.4544L9.80073 16.1221C9.21032 16.4701 8.4428 16.4701 7.79335 16.1221L4.13284 14.0343C3.54243 13.6863 3.12915 13.0485 3.12915 12.3525V8.23491C3.12915 7.53898 3.4834 6.90104 4.13284 6.55308L7.73431 4.52328C8.32472 4.17531 9.09224 4.17531 9.74169 4.52328L13.3432 6.55308C13.9335 6.90104 14.3469 7.53898 14.3469 8.23491V10.9027L17.476 9.10483V6.4371C17.476 5.74116 17.1218 5.10322 16.4723 4.75525L9.80073 0.927631C9.21032 0.579665 8.4428 0.579665 7.79335 0.927631L1.00369 4.75525C0.354243 5.10322 0 5.74116 0 6.4371V14.1504C0 14.8463 0.354243 15.4843 1.00369 15.8322L7.79335 19.6598C8.38375 20.0078 9.15129 20.0078 9.80073 19.6598L14.4059 17.0501L17.535 15.2522L22.1403 12.6425C22.7306 12.2945 23.4981 12.2945 24.1476 12.6425L27.7491 14.6723C28.3394 15.0202 28.7527 15.6582 28.7527 16.3541V20.4717C28.7527 21.1677 28.3985 21.8056 27.7491 22.1535L24.1476 24.2414C23.5571 24.5893 22.7896 24.5893 22.1403 24.2414L18.5388 22.2116C17.9483 21.8636 17.535 21.2256 17.535 20.5297V17.862L14.4059 19.6598V22.3275C14.4059 23.0234 14.7602 23.6614 15.4095 24.0094L22.1993 27.837C22.7896 28.1849 23.5571 28.1849 24.2066 27.837L30.9963 24.0094C31.5867 23.6614 32 23.0234 32 22.3275V14.6143C32 13.9183 31.6457 13.2805 30.9963 12.9325L24.1476 9.04684Z",
    fill: "#8247E5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonLogo);
export default __webpack_public_path__ + "static/media/polygon-logo.c89d2cae.svg";
export { ForwardRef as ReactComponent };